import { render, staticRenderFns } from "./ShopApply.vue?vue&type=template&id=4d9a8ab6&"
import script from "./ShopApply.vue?vue&type=script&lang=js&"
export * from "./ShopApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports